import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaPlus, FaMinus } from "react-icons/fa";

const faqData = [
  {
    category: "General",
    items: [
      {
        question: "How is your School an International School?",
        answer:
          "Our school follows both CBSE syllabus and has partnered with Cambridge and Newman University, U.K. We focus on multiculturalism and being a global citizen while rooted in the Indian tradition.",
      },
      {
        question: "How is your School different from others?",
        answer:
          "We recruit and retrain the best teachers, provide a safe learning environment, excellent infrastructure, modern sports facilities, international tie-ups and advisory members who support students in performing arts and sports.",
      },
      {
        question:
          "My child has a special need. Can he/she be included in the regular class?",
        answer:
          "Yes. We aim to include children with mild special educational needs in regular classrooms with support from our Special Needs Educator. Parents are requested to provide previous school reports and assessment records.",
      },
    ],
  },

  {
    category: "Discipline",
    items: [
      {
        question: "What is your philosophy of Discipline?",
        answer:
          "Discipline is based upon Respect for Self, Consideration for Others and Concern for the Environment.",
      },
    ],
  },

  {
    category: "Faculty",
    items: [
      {
        question:
          "Are students with the same teacher all day or different teachers?",
        answer:
          "Students from Nursery to Kindergarten have a Mother Teacher. From Class I onwards, different teachers teach different subjects.",
      },
      {
        question: "Are your Teachers experienced?",
        answer:
          "We recruit experienced teachers as well as trained graduates. Every teacher undergoes compulsory in-house training and continuous professional development.",
      },
      {
        question: "How are your Teachers trained and selected?",
        answer:
          "Teachers are recruited from reputed schools and trained according to the Learning Wings Education System philosophy at Cambridge International School for Girls, Jalandhar.",
      },
      {
        question: "What is the student-teacher ratio?",
        answer: "The student-teacher ratio is 1:10.",
      },
    ],
  },

  {
    category: "Fees",
    items: [
      {
        question: "How often will the fees be adjusted?",
        answer:
          "Sibling concession on full admission fees and various academic and sports scholarships are offered.",
      },
    ],
  },

  {
    category: "International Affiliations",
    items: [
      {
        question: "Are you using international academics?",
        answer:
          "We supplement our CBSE curriculum and Learning Wings training with international best practices from our partner schools.",
      },
      {
        question: "What is the nature of your International affiliations?",
        answer:
          "We have partnered with Wolverhampton University, U.K. and Ellesmere College, U.K. for teacher training, exchange programmes, school visits, joint projects, language and culture studies, and student exchange initiatives.",
      },
      {
        question: "Who is promoting this School?",
        answer: "The S.L. Angra Educational Society.",
      },
      {
        question: "Will my child get to study abroad?",
        answer:
          "Future opportunities for student exchange programmes will be available for older students. Families may also choose to host international students.",
      },
    ],
  },

  {
    category: "Parent Involvement",
    items: [
      {
        question: "How will I be informed of my child's progress?",
        answer:
          "Regular progress reports are shared by teachers. Parents may also schedule meetings with teachers, the Headmistress or the School Counsellor to discuss academic progress.",
      },
    ],
  },

  {
    category: "School Time",
    items: [
      {
        question: "What is the School Calendar Year?",
        answer:
          "The school calendar year is from April to March.",
      },
      {
        question: "What is the School Timing?",
        answer:
          "Summer Timings:\nNursery–Kindergarten: 9:00 AM – 12:00 PM\nPrimary & Middle: 8:30 AM – 2:30 PM",
      },
    ],
  },

  {
    category: "Transportation",
    items: [
      {
        question:
          "Is Transportation facility provided for Nursery/Kindergarten Students?",
        answer:
          "Yes, transportation facility is available for both Nursery and Kindergarten students.",
      },
      {
        question: "What supervision is available on the buses?",
        answer:
          "Every bus has a Driver, a Male Conductor and a Female Caretaker.",
      },
    ],
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(null);

  return (
    <section className="bg-white py-20">

      <div className="max-w-5xl mx-auto px-6">

        <div className="text-center mb-16">

          <p className="uppercase tracking-[6px] text-[#d4af37] font-bold mb-4">
            Cambridge International School
          </p>

          <h1 className="text-5xl md:text-6xl font-black text-[#07294d]">
            Frequently Asked Questions
          </h1>

          <div className="w-24 h-1 bg-[#d4af37] rounded-full mx-auto my-8"></div>

          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-9">
            Find answers to some of the most commonly asked questions about admissions, academics, faculty, transportation and school policies.
          </p>

        </div>
                {faqData.map((section, sectionIndex) => (

          <div key={sectionIndex} className="mb-14">

            <h2 className="text-3xl font-black text-[#07294d] mb-8 border-l-4 border-[#d4af37] pl-4">

              {section.category}

            </h2>

            <div className="space-y-5">

              {section.items.map((faq, index) => {

                const currentIndex = `${sectionIndex}-${index}`;

                return (

                  <motion.div
                    key={currentIndex}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="border border-gray-200 rounded-2xl overflow-hidden"
                  >

                    <button
                      onClick={() =>
                        setOpen(open === currentIndex ? null : currentIndex)
                      }
                      className="w-full flex justify-between items-center px-7 py-6 text-left bg-white hover:bg-gray-50 transition"
                    >

                      <h3 className="text-lg md:text-xl font-semibold text-[#07294d] pr-6">

                        {faq.question}

                      </h3>

                      <div className="text-[#07294d]">

                        {open === currentIndex ? (
                          <FaMinus />
                        ) : (
                          <FaPlus />
                        )}

                      </div>

                    </button>

                    {open === currentIndex && (

                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                        className="px-7 pb-7 text-gray-600 leading-8 whitespace-pre-line"
                      >

                        {faq.answer}

                      </motion.div>

                    )}

                  </motion.div>

                );

              })}

            </div>

          </div>

        ))}

      </div>

    </section>
  );
}